/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
import React, { useEffect, useState, useContext, useMemo } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { Button, Card, CardBody, Col, Container, Form, FormFeedback, FormGroup, Input, Label, Row } from 'reactstrap';

import { yupResolver } from '@hookform/resolvers/yup';

import CustomMaskedInput from '../../components/CustomMaskedInput';
import CustomSelectSearch from '../../components/CustomSelectSearch';
// import DatePickerMaskedInput from '../../components/DatePickerMaskedInput';
import MoneyMaskedInput from '../../components/MoneyMaskedInput';
import { AppContext } from '../../contexts/app';
import api from '../../services/api';
import { schema } from './validationSchema';

const months = [
  { value: 1, label: 'Jan' },
  { value: 2, label: 'Fev' },
  { value: 3, label: 'Mar' },
  { value: 4, label: 'Abr' },
  { value: 5, label: 'Mai' },
  { value: 6, label: 'Jun' },
  { value: 7, label: 'Jul' },
  { value: 8, label: 'Ago' },
  { value: 9, label: 'Set' },
  { value: 10, label: 'Out' },
  { value: 11, label: 'Nov' },
  { value: 12, label: 'Dez' },
];

const defaultValues = {
  contaPagarPara: 'profissional',
  mesCobranca: `${new Date().getMonth() + 1}-${new Date().getFullYear()}`,
  tipoConta: 'nota-fiscal',
};

function ContaPagar() {
  const navigate = useNavigate();
  const { loading, setLoading, notificationRef } = useContext(AppContext);
  const [profissionais, setProfissionais] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [fornecedores, setFornecedores] = useState([]);
  const [especialidades, setEspecialidades] = useState([]);
  const [dataVencimentoInfo, setDataVencimentoInfo] = useState('');
  const [loadingDataVencimento, setLoadingDataVencimento] = useState(false);
  const { control, watch, setError, handleSubmit, formState: { errors }, setValue } = useForm({ defaultValues, resolver: yupResolver(schema) });
  const watchContaPagarPara = watch('contaPagarPara');
  const watchMesCobranca = watch('mesCobranca');

  const mesAnoFilter = useMemo(
    () => {
      const filterCurrentYear = new Date().getFullYear();
      const nextYear = filterCurrentYear + 1;
      const previousYear = filterCurrentYear - 1;

      const filters = [];

      // Adiciona meses do ano anterior
      months.forEach((month) => {
        filters.push({
          value: `${month.value}-${previousYear}`,
          label: `${month.label}/${previousYear}`,
        });
      });

      // Adiciona meses do ano atual
      months.forEach((month) => {
        filters.push({
          value: `${month.value}-${filterCurrentYear}`,
          label: `${month.label}/${filterCurrentYear}`,
        });
      });

      // Adiciona meses do próximo ano
      months.forEach((month) => {
        filters.push({
          value: `${month.value}-${nextYear}`,
          label: `${month.label}/${nextYear}`,
        });
      });

      return filters;
    },
    [],
  );

  useEffect(() => {
    const loadProfissionais = async () => {
      const { data = [] } = await api.get('/profissionais?limit=0');
      return data;
    };

    const loadFornecedores = async () => {
      const { data = [] } = await api.get('/fornecedores?limit=0');
      return data;
    };

    const loadClientes = async () => {
      const { data = [] } = await api.get('/users?limit=0');
      return data;
    };

    const loadEspecialidades = async () => {
      const { data = [] } = await api.get('/especialidades?limit=0');
      return data;
    };

    (async () => {
      try {
        const [profissionaisData = [], fornecedoresData = [], clientesData = [], especialidadesData = []] = await Promise.all([loadProfissionais(), loadFornecedores(), loadClientes(), loadEspecialidades()]);
        // console.log(profissionaisData, fornecedoresData);
        setProfissionais(profissionaisData.map((d) => ({
          value: d._id,
          label: d.name,
        })));

        setFornecedores(fornecedoresData.map((d) => ({
          value: d._id,
          label: d.nome,
        })));

        setClientes(clientesData.map((d) => ({
          value: d._id,
          label: d.criancas.nome,
          cpf: d.criancas.cpf,
          razaoSocial: d.criancas.razaoSocial,
          cnpj: d.criancas.cnpj,
        })));

        setEspecialidades(especialidadesData.map((d) => ({
          value: d._id,
          label: d.nome,
          cor: d.cor,
        })));
      } catch (error) {
        console.log(error);
      }
    })();
  }, []);

  useEffect(() => {
    const fetchDataVencimento = async () => {
      if (watchMesCobranca) {
        setLoadingDataVencimento(true);
        try {
          const [month, year] = watchMesCobranca.split('-');
          const dataCobranca = new Date(year, month - 1, 1);
          const { data } = await api.get(`/generate-data-vencimento?dataBase=${dataCobranca.toISOString()}`);
          setDataVencimentoInfo(data.dataVencimentoFormatada || '');
        } catch (error) {
          console.log('Erro ao buscar data de vencimento:', error);
          setDataVencimentoInfo('');
        } finally {
          setLoadingDataVencimento(false);
        }
      } else {
        setDataVencimentoInfo('');
        setLoadingDataVencimento(false);
      }
    };

    fetchDataVencimento();
  }, [watchMesCobranca]);

  const resetFields = () => {
    setValue('contaPagarPara', 'profissional');
    setValue('fornecedor', '');
    setValue('profissional', '');
    setValue('cliente', '');
    setValue('razaoSocial', '');
    setValue('cnpj', '');
    setValue('especialidade', '');
    setValue('horas', '');
    setValue('valor', '');
    setValue('mesCobranca', `${new Date().getMonth() + 1}-${new Date().getFullYear()}`);
    setValue('dataVencimento', '');
    setValue('observacoes', '');
    setValue('tipoConta', 'nota-fiscal');
    setDataVencimentoInfo('');
    setLoadingDataVencimento(false);
    window.location.reload();
  };

  const onSubmit = (formValues) => {
    const { contaPagarPara, fornecedor, profissional, horas, valor, dataVencimento, observacoes, cliente, especialidade, razaoSocial, cnpj, mesCobranca, tipoConta } = formValues;
    console.log(formValues);

    (async () => {
      try {
        if (contaPagarPara === 'fornecedor' && !fornecedor) {
          setError('fornecedor', { type: 'manual', message: 'Selecione um fornecedor' });
          return;
        }

        if (contaPagarPara === 'profissional' && !profissional) {
          setError('profissional', { type: 'manual', message: 'Selecione um profissional' });
          return;
        }

        if (contaPagarPara === 'cliente' && !cliente) {
          setError('cliente', { type: 'manual', message: 'Selecione um cliente' });
          return;
        }

        if (contaPagarPara !== 'fornecedor' && !especialidade) {
          setError('especialidade', { type: 'manual', message: 'Selecione um tipo de atendimento' });
          return;
        }

        setLoading(true);

        // Create dataCobranca from mesCobranca (format: "month-year")
        let dataCobranca = null;
        if (mesCobranca) {
          const [month, year] = mesCobranca.split('-');
          dataCobranca = new Date(year, month - 1, 1); // month is 0-indexed in Date constructor
        }

        // Handle "Outros Créditos e Débitos" type
        let valorFinal = valor;
        let outrosDebitosCreditos = null;

        if (tipoConta === 'outros-creditos-debitos') {
          outrosDebitosCreditos = valor;
          valorFinal = 0;
        }

        const data = {
          tipo: 'conta-pagar',
          contaDe: contaPagarPara,
          horas,
          valor: valorFinal,
          dataVencimento,
          dataCobranca,
          observacoes,
          especialidade,
          profissional,
          razaoSocial,
          cnpj,
        };

        if (outrosDebitosCreditos !== null) {
          data.outrosDebitosCreditos = outrosDebitosCreditos;
        }

        const _profissional = profissionais.find((p) => p.value === (profissional?.value || profissional));
        if (_profissional) {
          Object.assign(data, {
            profissional: _profissional?.value,
          });
        }

        const _cliente = clientes.find((c) => c.value === (cliente?.value || cliente));
        if (_cliente) {
          Object.assign(data, {
            cliente: {
              id: _cliente?.value,
              nome: _cliente?.label,
              cpf: _cliente?.cpf,
            },
          });
        }

        if (contaPagarPara === 'fornecedor') {
          const _fornecedor = fornecedores.find((f) => f.value === (fornecedor?.value || fornecedor));
          Object.assign(data, {
            fornecedor: _fornecedor?.value,
          });
        }

        console.log(data);
        await api.post('/financeiros', data);
        setLoading(false);
        notificationRef.current.notify({
          message: 'Conta a pagar criada com sucesso',
        });

        setTimeout(() => {
          navigate('/lancamentos-administrativos');
        }, 1000);

        resetFields();
      } catch (err) {
        console.log(err);
        setLoading(false);
        if (err && err.response && err.response.data) {
          const { message } = err.response.data;

          if (message) {
            notificationRef.current.notify({
              message,
              color: 'danger',
            });

            return;
          }
        }

        notificationRef.current.notify({
          message: 'Falha ao cadastrar fatura',
          color: 'danger',
        });
      }
    })();
  };

  return (
    <Container fluid>
      <Row className="mt-5">
        <Col>
          <Card>
            <CardBody>
              <Row>
                <Col>
                  <h3>Cadastrar Conta a Pagar</h3>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Row>
          <Col>
            <Card>
              <CardBody>
                <Row className="mb-4">
                  <Col>
                    <Controller
                      name="contaPagarPara"
                      control={control}
                      render={({ field: { value, onChange } }) => (
                        <FormGroup check>
                          <Input
                            type="radio"
                            value="fornecedor"
                            checked={value === 'fornecedor'}
                            onChange={onChange}
                          />
                          <Label check>Fornecedor</Label>
                        </FormGroup>
                      )}
                    />
                  </Col>
                </Row>
                <Row className="mb-4">
                  <Col>
                    <Controller
                      name="contaPagarPara"
                      control={control}
                      render={({ field: { value, onChange } }) => (
                        <FormGroup check>
                          <Input
                            type="radio"
                            value="profissional"
                            checked={value === 'profissional'}
                            onChange={onChange}
                          />
                          <Label check>Profissional</Label>
                        </FormGroup>
                      )}
                    />
                  </Col>
                </Row>
                <Row className="mb-5">
                  <Col>
                    <Controller
                      name="contaPagarPara"
                      control={control}
                      render={({ field: { value, onChange } }) => (
                        <FormGroup check>
                          <Input
                            type="radio"
                            value="cliente"
                            checked={value === 'cliente'}
                            onChange={onChange}
                          />
                          <Label check>Cliente</Label>
                        </FormGroup>
                      )}
                    />
                  </Col>
                </Row>
                {watchContaPagarPara === 'fornecedor' ? (
                  <>
                    <Row>
                      <Col>
                        <Controller
                          name="fornecedor"
                          control={control}
                          render={({ field: { onChange, name, value } }) => (
                            <FormGroup>
                              <Label for="fornecedorSelect">
                                Fornecedor
                              </Label>
                              <CustomSelectSearch
                                id="fornecedorSelect"
                                name={name}
                                value={value}
                                onChange={onChange}
                                options={fornecedores}
                                placeholder="Selecione um Fornecedor"
                                invalid={!!errors?.fornecedor?.message}
                                errorMessage={errors?.fornecedor?.message}
                                loadingMessage="Carregando fornecedores"
                                noOptionsMessage="Nenhum fornecedor encontrado"
                              />
                            </FormGroup>
                          )}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Controller
                          name="razaoSocial"
                          control={control}
                          render={({ field: { onChange, name, value } }) => (
                            <FormGroup>
                              <Label for="razaoSocial">Empresa</Label>
                              <Input
                                id="razaoSocial"
                                type="text"
                                placeholder="Empresa"
                                name={name}
                                value={value || ''}
                                onChange={onChange}
                                invalid={!!errors?.razaoSocial?.message}
                              />
                              <FormFeedback>{errors?.razaoSocial?.message}</FormFeedback>
                            </FormGroup>
                          )}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Controller
                          name="cnpj"
                          control={control}
                          render={({ field: { onChange, name, value } }) => (
                            <CustomMaskedInput
                              id="cnpj"
                              label="CNPJ"
                              placeholder="Informe um CNPJ"
                              format="##.###.###/####-##"
                              name={name}
                              value={value}
                              onValueChange={({ value: v }) => onChange(v)}
                              invalidMessage={errors?.cnpj?.message}
                            />
                          )}
                        />
                      </Col>
                    </Row>
                  </>
                ) : watchContaPagarPara === 'profissional' ? (
                  <Row>
                    <Col>
                      <Controller
                        name="profissional"
                        control={control}
                        render={({ field: { onChange, name, value } }) => (
                          <FormGroup>
                            <Label for="profissionalSelect">
                              Profissional
                            </Label>
                            <CustomSelectSearch
                              id="profissionalSelect"
                              name={name}
                              value={value}
                              onChange={onChange}
                              options={profissionais}
                              placeholder="Selecione um Profissional"
                              invalid={!!errors?.profissional?.message}
                              errorMessage={errors?.profissional?.message}
                              loadingMessage="Carregando profissionais"
                              noOptionsMessage="Nenhum profissional encontrado"
                            />
                          </FormGroup>
                        )}
                      />
                    </Col>
                  </Row>
                ) : (
                  <Row>
                    <Col>
                      <Controller
                        name="cliente"
                        control={control}
                        render={({ field: { onChange, name, value } }) => (
                          <FormGroup>
                            <Label for="clienteSelect">
                              Cliente
                            </Label>
                            <CustomSelectSearch
                              id="clienteSelect"
                              name={name}
                              value={value}
                              onChange={(e) => {
                                const cliente = clientes.find((c) => c.value === e);
                                onChange(e);
                                setValue('razaoSocial', cliente?.razaoSocial || '');
                                setValue('cnpj', cliente?.cnpj || '');
                              }}
                              options={clientes}
                              placeholder="Selecione um Cliente"
                              invalid={!!errors?.cliente?.message}
                              errorMessage={errors?.cliente?.message}
                              loadingMessage="Carregando clientes"
                              noOptionsMessage="Nenhum cliente encontrado"
                            />
                          </FormGroup>
                        )}
                      />
                    </Col>
                  </Row>
                )}
                {watchContaPagarPara === 'cliente' && (
                  <>
                    <Row>
                      <Col>
                        <Controller
                          name="profissional"
                          control={control}
                          render={({ field: { onChange, name, value } }) => (
                            <FormGroup>
                              <Label for="profissionalSelect">
                                Especialista
                              </Label>
                              <CustomSelectSearch
                                id="profissionalSelect"
                                name={name}
                                value={value}
                                onChange={onChange}
                                options={profissionais}
                                placeholder="Selecione um Especialista"
                                invalid={!!errors?.profissional?.message}
                                errorMessage={errors?.profissional?.message}
                                loadingMessage="Carregando especialistas"
                                noOptionsMessage="Nenhum especialista encontrado"
                                onRenderLabel={(option) => (
                                  <div className="d-flex align-items-center">
                                    <div style={{ backgroundColor: option.cor, width: '20px', height: '20px', borderRadius: '10px', marginRight: '0.5rem' }} />
                                    {option.label}
                                  </div>
                                )}
                              />
                            </FormGroup>
                          )}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Controller
                          name="razaoSocial"
                          control={control}
                          render={({ field: { onChange, name, value } }) => (
                            <FormGroup>
                              <Label for="razaoSocial">Empresa</Label>
                              <Input
                                id="razaoSocial"
                                type="text"
                                placeholder="Empresa"
                                name={name}
                                value={value || ''}
                                onChange={onChange}
                                invalid={!!errors?.razaoSocial?.message}
                              />
                              <FormFeedback>{errors?.razaoSocial?.message}</FormFeedback>
                            </FormGroup>
                          )}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Controller
                          name="cnpj"
                          control={control}
                          render={({ field: { onChange, name, value } }) => (
                            <CustomMaskedInput
                              id="cnpj"
                              label="CNPJ"
                              placeholder="Informe um CNPJ"
                              format="##.###.###/####-##"
                              name={name}
                              value={value}
                              onValueChange={({ value: v }) => onChange(v)}
                              invalidMessage={errors?.cnpj?.message}
                            />
                          )}
                        />
                      </Col>
                    </Row>
                  </>
                )}
                {watchContaPagarPara === 'profissional' && (
                  <>
                    <Row>
                      <Col>
                        <Controller
                          name="cliente"
                          control={control}
                          render={({ field: { onChange, name, value } }) => {
                            console.log(value);
                            return (
                              <FormGroup>
                                <Label for="clienteSelect">
                                  Paciente
                                </Label>
                                <CustomSelectSearch
                                  id="clienteSelect"
                                  name={name}
                                  value={value}
                                  onChange={(e) => {
                                    const cliente = clientes.find((c) => c.value === e);
                                    onChange(e);
                                    setValue('razaoSocial', cliente?.razaoSocial || '');
                                    setValue('cnpj', cliente?.cnpj || '');
                                  }}
                                  options={clientes}
                                  placeholder="Selecione um Paciente"
                                  invalid={!!errors?.cliente?.message}
                                  errorMessage={errors?.cliente?.message}
                                  loadingMessage="Carregando pacientes"
                                  noOptionsMessage="Nenhum paciente encontrado"
                                />
                              </FormGroup>
                            );
                          }}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Controller
                          name="razaoSocial"
                          control={control}
                          render={({ field: { onChange, name, value } }) => (
                            <FormGroup>
                              <Label for="razaoSocial">Empresa</Label>
                              <Input
                                id="razaoSocial"
                                type="text"
                                placeholder="Empresa"
                                name={name}
                                value={value || ''}
                                onChange={onChange}
                                invalid={!!errors?.razaoSocial?.message}
                              />
                              <FormFeedback>{errors?.razaoSocial?.message}</FormFeedback>
                            </FormGroup>
                          )}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Controller
                          name="cnpj"
                          control={control}
                          render={({ field: { onChange, name, value } }) => (
                            <CustomMaskedInput
                              id="cnpj"
                              label="CNPJ"
                              placeholder="Informe um CNPJ"
                              format="##.###.###/####-##"
                              name={name}
                              value={value}
                              onValueChange={({ value: v }) => onChange(v)}
                              invalidMessage={errors?.cnpj?.message}
                            />
                          )}
                        />
                      </Col>
                    </Row>
                  </>
                )}
                {watchContaPagarPara !== 'fornecedor' && (
                  <>
                    <Row>
                      <Col>
                        <Controller
                          name="especialidade"
                          control={control}
                          render={({ field: { onChange, name, value } }) => (
                            <FormGroup>
                              <Label for="especialidadeSelect">
                                Tipo de Atendimento
                              </Label>
                              <CustomSelectSearch
                                id="especialidadeSelect"
                                name={name}
                                value={value}
                                onChange={onChange}
                                options={especialidades}
                                placeholder="Selecione um Tipo de Atendimento"
                                invalid={!!errors?.especialidade?.message}
                                errorMessage={errors?.especialidade?.message}
                                loadingMessage="Carregando tipos de atendimento"
                                noOptionsMessage="Nenhum tipo de atendimento encontrado"
                                onRenderLabel={(option) => (
                                  <div className="d-flex align-items-center">
                                    <div style={{ backgroundColor: option.cor, width: '20px', height: '20px', borderRadius: '10px', marginRight: '0.5rem' }} />
                                    {option.label}
                                  </div>
                                )}
                              />
                            </FormGroup>
                          )}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Controller
                          name="horas"
                          control={control}
                          render={({ field: { onChange, name, value } }) => (
                            <FormGroup>
                              <Label for="horas">Horas</Label>
                              <Input
                                id="horas"
                                type="time"
                                placeholder="Horas"
                                name={name}
                                value={value || ''}
                                onChange={onChange}
                                invalid={!!errors?.horas?.message}
                              />
                              <FormFeedback>{errors?.horas?.message}</FormFeedback>
                            </FormGroup>
                          )}
                        />
                      </Col>
                    </Row>
                  </>
                )}
                <Row>
                  <Col>
                    <Controller
                      name="tipoConta"
                      control={control}
                      render={({ field: { onChange, name, value } }) => (
                        <FormGroup>
                          <Label for="tipoConta">Tipo de Conta</Label>
                          <Input
                            type="select"
                            id="tipoConta"
                            name={name}
                            value={value || 'nota-fiscal'}
                            onChange={onChange}
                            invalid={!!errors?.tipoConta?.message}
                          >
                            <option value="nota-fiscal">Nota Fiscal</option>
                            <option value="outros-creditos-debitos">Outros Créditos e Débitos</option>
                          </Input>
                          <FormFeedback>{errors?.tipoConta?.message}</FormFeedback>
                        </FormGroup>
                      )}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Controller
                      name="valor"
                      control={control}
                      render={({ field: { onChange, name, value } }) => (
                        <MoneyMaskedInput
                          label="Valor"
                          name={name}
                          invalidMessage={errors?.valor?.message}
                          value={value}
                          onValueChange={({ floatValue }) => onChange(floatValue)}
                        />
                      )}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Controller
                      name="mesCobranca"
                      control={control}
                      render={({ field: { onChange, name, value } }) => (
                        <FormGroup>
                          <Label for="mesCobranca">Mês Cobrança</Label>
                          <Input
                            type="select"
                            id="mesCobranca"
                            name={name}
                            value={value || ''}
                            onChange={onChange}
                            invalid={!!errors?.mesCobranca?.message}
                          >
                            <option value="">Selecione</option>
                            {mesAnoFilter.map((s) => (
                              <option key={s.value} value={s.value}>
                                {s.label}
                              </option>
                            ))}
                          </Input>
                          <FormFeedback>{errors?.mesCobranca?.message}</FormFeedback>
                        </FormGroup>
                      )}
                    />
                  </Col>
                </Row>
                {(dataVencimentoInfo || loadingDataVencimento) && (
                <Row>
                  <Col>
                    <div className="text-muted small mt-2 mb-5">
                      {loadingDataVencimento ? (
                        <>
                          <i className="fas fa-spinner fa-spin mr-2" />
                          Carregando data de vencimento...
                        </>
                      ) : (
                        <>
                          <i className="fas fa-info-circle mr-2" />
                          A data de vencimento será gerada para o quinto dia útil do mês seguinte:
                          {' '}
                          <strong>{dataVencimentoInfo}</strong>
                        </>
                      )}
                    </div>
                  </Col>
                </Row>
                )}
                {/* <Row>
                  <Col>
                    <Controller
                      name="dataVencimento"
                      control={control}
                      render={({ field }) => (
                        <DatePickerMaskedInput
                          label="Data do Vencimento"
                          invalidMessage={errors?.dataVencimento?.message}
                          onChange={(e) => field.onChange(e)}
                          selected={field.value}
                        />
                      )}
                    />
                  </Col>
                </Row> */}
                <Row>
                  <Col>
                    <Controller
                      name="observacoes"
                      control={control}
                      render={({ field }) => (
                        <FormGroup>
                          <Label>Observações</Label>
                          <Input
                            type="textarea"
                            {...field}
                          />
                        </FormGroup>
                      )}
                    />
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row className="mt-5">
          <Col xs={12} sm={6}>
            <Button type="submit" color="success" disabled={loading} block>Cadastrar</Button>
          </Col>
          <Col xs={12} sm={6}>
            <Button color="danger" disabled={loading} onClick={() => navigate(-1)} block>Cancelar</Button>
          </Col>
        </Row>
      </Form>
    </Container>
  );
}

export default ContaPagar;
